/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Students_Title_AccentInputs */

const en_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`helped develop`)
};

const es_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ayudado a desarrollar`)
};

const de_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gefördert hat`)
};

const zh_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冠军们`)
};

const ar_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`في تطويرهم`)
};

const fr_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a aidé à former`)
};

const vi_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`giúp phát triển`)
};

const sw_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`amewasaidia kukua`)
};

const th_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วยปั้น`)
};

const bs_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pomogao razviti`)
};

const ja_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャンピオンたち`)
};

const ko_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챔피언들`)
};

const pt_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ajudou a formar`)
};

const it_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ha aiutato a crescere`)
};

const sv_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`har hjälpt fram`)
};

const nl_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`helpen ontwikkelen`)
};

const da_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`har hjulpet frem`)
};

const nb_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hjulpet fram`)
};

const fi_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on auttanut kehittymään`)
};

const pl_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wychował Mark`)
};

const ru_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вырастил Mark`)
};

const tr_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`katkı sağladığı şampiyonlar`)
};

const hi_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चैंपियन`)
};

const id_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dibina Mark`)
};

const ms_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dibimbing Mark`)
};

const cs_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pomohl vychovat`)
};

const el_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ανέδειξε ο Mark`)
};

const he_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עזר לפתח`)
};

const af_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`help ontwikkel`)
};

const hu_about_students_title_accent = /** @type {(inputs: About_Students_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark nevelt`)
};

/**
* | output |
* | --- |
* | "helped develop" |
*
* @param {About_Students_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_students_title_accent = /** @type {((inputs?: About_Students_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Students_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_students_title_accent(inputs)
	if (locale === "de") return de_about_students_title_accent(inputs)
	if (locale === "zh") return zh_about_students_title_accent(inputs)
	if (locale === "ar") return ar_about_students_title_accent(inputs)
	if (locale === "fr") return fr_about_students_title_accent(inputs)
	if (locale === "vi") return vi_about_students_title_accent(inputs)
	if (locale === "sw") return sw_about_students_title_accent(inputs)
	if (locale === "th") return th_about_students_title_accent(inputs)
	if (locale === "bs") return bs_about_students_title_accent(inputs)
	if (locale === "ja") return ja_about_students_title_accent(inputs)
	if (locale === "ko") return ko_about_students_title_accent(inputs)
	if (locale === "pt") return pt_about_students_title_accent(inputs)
	if (locale === "it") return it_about_students_title_accent(inputs)
	if (locale === "sv") return sv_about_students_title_accent(inputs)
	if (locale === "nl") return nl_about_students_title_accent(inputs)
	if (locale === "da") return da_about_students_title_accent(inputs)
	if (locale === "nb") return nb_about_students_title_accent(inputs)
	if (locale === "fi") return fi_about_students_title_accent(inputs)
	if (locale === "pl") return pl_about_students_title_accent(inputs)
	if (locale === "ru") return ru_about_students_title_accent(inputs)
	if (locale === "tr") return tr_about_students_title_accent(inputs)
	if (locale === "hi") return hi_about_students_title_accent(inputs)
	if (locale === "id") return id_about_students_title_accent(inputs)
	if (locale === "ms") return ms_about_students_title_accent(inputs)
	if (locale === "cs") return cs_about_students_title_accent(inputs)
	if (locale === "el") return el_about_students_title_accent(inputs)
	if (locale === "he") return he_about_students_title_accent(inputs)
	if (locale === "af") return af_about_students_title_accent(inputs)
	if (locale === "hu") return hu_about_students_title_accent(inputs)
	return en_about_students_title_accent(inputs)
});